// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.songwriter-hub-intro .footer-block .button-component button {
  text-wrap: auto;
}
.songwriter-hub-intro .welcome-popup > .second-step > img {
  width: 50%;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Popups/SongwriterHubWelcomePopup/index.scss"],"names":[],"mappings":"AAGM;EACE,eAAA;AAFR;AAME;EACE,UAAA;AAJJ","sourcesContent":[".songwriter-hub-intro {\n  .footer-block {\n    .button-component {\n      button {\n        text-wrap: auto;\n      }\n    }\n  }\n  .welcome-popup > .second-step > img {\n    width: 50%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
